import chapter1 from'./chapter1';
import chapter2 from'./chapter2';

const plot = [
  ...chapter1,
  ...chapter2
];

export default plot;
